import { useMemo } from 'react'

import { usePagination } from '@app/hooks/usePagination'

import { getPaginationParams } from '@app/utils'

import type { PaginationParamsHookReturn } from '@app/types/pagination'

export const usePaginationParams = (): PaginationParamsHookReturn => {
  const { pagination, setPagination, resetCurrentPage } = usePagination()

  const paginationParams = useMemo(() => getPaginationParams(pagination), [pagination])

  return {
    paginationParams,
    pagination,
    setPagination,
    resetCurrentPage
  }
}
